

const brewerEmailsStore = {
    //State variables
    state: {
        countiesForEmail:[],
        usersForEmail:[],
        manualEmails:[],
    },

    //Mutations
    mutations: {
        //Set selected counties for email
        setCountiesForEmail(state,val){
            console.log("Setting counties = " + val)
            state.countiesForEmail = val
        },
        setUsersForEmail(state,val){
            console.log("Setting users = " + val)
            state.usersForEmail = val
        },
        setManualEmails(state,val){
            console.log("Setting manual emails = " + val)
            state.manualEmails = val
        },
    }
}

export default brewerEmailsStore